enum SupplyTypes {
  GOODS = 1,
  SERVICES = 2,
}

export default SupplyTypes;
